import React, { useState } from "react";

import { TabContainer } from "@apps/MarketsApp/components/TabContainer";
import { TabTitle } from "@apps/MarketsApp/components/TabTitle";
import VideoPlayer from "../../icons/video_player.svg";
import VideoPlaceholder from "./icons/video_placeholder.png";
import { VideoPlayerModal } from "@apps/MarketsApp/components/VideoPlayerModal";
import { PitchesList } from "./components/PitchesList";
import { FaqSection } from "./components/FaqSection";
import SearchIcon from "./icons/search.svg";
import CloseIcon from "@assets/svg/close.svg";
import InputV2 from "@appComponents/InputV2";

const PrivateEquityMarket = () => {
  const [showPlayer, setShowPlayer] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isVideoBannerOpen, setIsVideoBannerOpen] = useState(true);

  return (
    <>
      <TabContainer>
        <div className="flex md:flex-row flex-col md:items-center gap-4 justify-between">
          <TabTitle>Private Equity Primary Market</TabTitle>

          <InputV2
            value={searchQuery}
            leftIcon={<SearchIcon />}
            placeholder="Search"
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {isVideoBannerOpen && (
          <div className="rounded-[12px] bg-[#F0EFFA] p-6 mt-4 grid md:grid-cols-[132px_1fr] gap-8 relative pt-[30px] md:pt-6">
            <div
              className="absolute top-4 right-4 cursor-pointer"
              onClick={() => setIsVideoBannerOpen(false)}
            >
              <CloseIcon />
            </div>

            <div className="relative">
              <button
                onClick={() => setShowPlayer(true)}
                className="bg-transparent p-0 absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2"
              >
                <VideoPlayer />
              </button>
              <img className="w-full" src={VideoPlaceholder} />
            </div>

            <div className="md:h-full flex flex-col md:justify-between">
              <div>
                <div className="font-bold">
                  What is the Private Equity Primary Market?
                </div>
                <div>
                  The Private Equity Primary Market is where BF users can access
                  both current and past investment opportunities launched
                  through the platform. BF typically launches one or two new
                  deals each year. You can view all Primary Market deals below.
                </div>
              </div>

              <div className="flex gap-8">
                <a
                  className="underline font-semibold"
                  onClick={() => setShowPlayer(true)}
                >
                  Watch video
                </a>
              </div>
            </div>
          </div>
        )}

        <PitchesList searchQuery={searchQuery} />

        <div className="border border-grey-lighter rounded-[12px] px-8 py-4 md:mt-[50px] mt-[20px]">
          <FaqSection />
        </div>
      </TabContainer>

      <VideoPlayerModal
        videoId="cK0aYTlgtUI"
        open={showPlayer}
        onClose={() => setShowPlayer(false)}
      />
    </>
  );
};

export default PrivateEquityMarket;
